import { Action } from 'redux'
import { ReportMenuModel } from '../Model'
import { actionTypes } from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export interface IReportMenuState {
  data?: {
    reportMenu?: ReportMenuModel[]
    meta?: { [key: string]: string | number }[]
  }
  deleteSuccess?: boolean
  enableSuccess?: boolean
  disableSuccess?: boolean
  singleEnableSuccess?: boolean
  singleDisableSuccess?: boolean
  loading?: boolean
  toggleLoading?: boolean
  success?: boolean
}

const initialState: IReportMenuState = {
  data: {
    reportMenu: [],
    meta: [],
  },
  deleteSuccess: false,
  enableSuccess: false,
  disableSuccess: false,
  singleEnableSuccess: false,
  singleDisableSuccess: false,
  loading: false,
  toggleLoading: false,
  success: false,
}

export const reducer = (
  state: IReportMenuState = initialState,
  action: ActionWithPayload<IReportMenuState>
) => {
  switch (action.type) {
    case actionTypes.GET_REPORT_MENU_START:
      return { ...state, loading: true }
    case actionTypes.GET_REPORT_MENU_SUCCESS:
      return { ...state, data: action.payload, loading: false }
    case actionTypes.GET_REPORT_MENU_FINISH:
      return { ...state, loading: false }

    case actionTypes.ADD_REPORT_MENU_START:
      return { ...state, loading: true }
    case actionTypes.ADD_REPORT_MENU_SUCCESS:
      return { ...state, success: true, loading: false }
    case actionTypes.ADD_REPORT_MENU_FINISH:
      return { ...state, loading: false }
    case actionTypes.RESET_REPORT_MENU:
      return { ...state, success: false, data: { reportMenu: [], meta: [] } }

    case actionTypes.UPDATE_REPORT_MENU_START:
      return { ...state, loading: true }
    case actionTypes.UPDATE_REPORT_MENU_SUCCESS:
      return { ...state, success: true, loading: false }
    case actionTypes.UPDATE_REPORT_MENU_FINISH:
      return { ...state, loading: false }

    case actionTypes.DELETE_REPORT_MENU_START:
      return { ...state, loading: true }
    case actionTypes.DELETE_REPORT_MENU_SUCCESS:
      return { ...state, deleteSuccess: true, loading: false }
    case actionTypes.DELETE_REPORT_MENU_FINISH:
      return { ...state, loading: false, deleteSuccess: false }

    case actionTypes.SINGLE_ENABLE_REPORT_MENU_REQUEST:
      return { ...state, toggleLoading: true }
    case actionTypes.SINGLE_ENABLE_REPORT_MENU_SUCCESS: {
      const id = (action.payload as any)?.id
      const newData = state?.data?.reportMenu?.map((item) =>
        item?.id === id ? { ...item, is_active: true } : item
      )
      return {
        ...state,
        data: { ...state.data, reportMenu: newData },
        singleEnableSuccess: true,
        toggleLoading: false,
      }
    }
    case actionTypes.SINGLE_ENABLE_REPORT_MENU_FINISH:
      return { ...state, singleEnableSuccess: false, toggleLoading: false }

    case actionTypes.SINGLE_DISABLE_REPORT_MENU_REQUEST:
      return { ...state, toggleLoading: true }
    case actionTypes.SINGLE_DISABLE_REPORT_MENU_SUCCESS: {
      const id = (action.payload as any)?.id
      const newData = state?.data?.reportMenu?.map((item) =>
        item?.id === id ? { ...item, is_active: false } : item
      )
      return {
        ...state,
        data: { ...state.data, reportMenu: newData },
        singleDisableSuccess: true,
        toggleLoading: false,
      }
    }
    case actionTypes.SINGLE_DISABLE_REPORT_MENU_FINISH:
      return { ...state, singleDisableSuccess: false, toggleLoading: false }

    case actionTypes.ENABLE_REPORT_MENU_REQUEST:
      return { ...state, loading: true }
    case actionTypes.ENABLE_REPORT_MENU_SUCCESS:
      return { ...state, enableSuccess: true, loading: false }
    case actionTypes.ENABLE_REPORT_MENU_FINISH:
      return { ...state, loading: false, enableSuccess: false }

    case actionTypes.DISABLE_REPORT_MENU_REQUEST:
      return { ...state, loading: true }
    case actionTypes.DISABLE_REPORT_MENU_SUCCESS:
      return { ...state, disableSuccess: true, loading: false }
    case actionTypes.DISABLE_REPORT_MENU_FINISH:
      return { ...state, loading: false, disableSuccess: false }

    default:
      return state
  }
}
